module.exports = __webpack_public_path__ + "img/agape_header.15e6a8b2.png";